export const SliderCode = {
	copilotDisabled: 'limit_copilot_off',
	historyLimited: 'limit_office_chating_history',
	autoDeleteDisabled: 'limit_auto_delete_messages_off',
	collabInviteOff: 'limit_v2_socialnetwork_collab_invite_off',
	collabDisabled: 'socialnetwork_collab_off',
	buyMarketPlus: 'limit_subscription_market_access_buy_marketplus',
};
